import { ChartType } from '../types/prism';
export const chartTypeToScriptUrlMap = {
    [ChartType.AdvancedPivotTable]: () => import('@thoughtspot/valkyrie-charts/lib/exports/pivot'),
    [ChartType.AdvancedBar]: () => import('@thoughtspot/valkyrie-charts/lib/exports/bar'),
    [ChartType.AdvancedColumn]: () => import('@thoughtspot/valkyrie-charts/lib/exports/column'),
    [ChartType.AdvancedStackedColumn]: () => import('@thoughtspot/valkyrie-charts/lib/exports/stacked-column'),
    [ChartType.AdvancedStackedBar]: () => import('@thoughtspot/valkyrie-charts/lib/exports/stacked-bar'),
    [ChartType.AdvancedLine]: () => import('@thoughtspot/valkyrie-charts/lib/exports/line'),
    [ChartType.AdvancedArea]: () => import('@thoughtspot/valkyrie-charts/lib/exports/area'),
    [ChartType.AdvancedStackedArea]: () => import('@thoughtspot/valkyrie-charts/lib/exports/stacked-area'),
    [ChartType.AdvancedLineColumn]: () => import('@thoughtspot/valkyrie-charts/lib/exports/line-column'),
    [ChartType.AdvancedLineStackedColumn]: () => import('@thoughtspot/valkyrie-charts/lib/exports/line-stacked-column'),
    [ChartType.MuzeStudio]: () => import('@thoughtspot/dyoc/lib/'),
};
//# sourceMappingURL=chart-type-url-map.js.map